import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'utils/axiosBaseQuery';

// Define a service using a base URL and expected endpoints
export const addressApi = createApi({
  reducerPath: 'addressApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['address'],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getAddressList: builder.query({
      query: ({ filter }) => ({
        method: 'GET',
        path: `Customer/GetAllCustomers/${filter}`,
      }),
    }),
    getCustomerInfoById: builder.query({
      query: ({ id }) => ({
        method: 'GET',
        path: `Customer/GetCustomer/${id}`,
      }),
      providesTags: ['address'],
    }),
    getAddressBookById: builder.query({
      query: ({ id, isActive=true }) => ({
        method: 'GET',
        path: `Addresses/GetAddressBook/${id}?isActive=${isActive}`,
      }),
      providesTags: ['address'],
    }),
    getActiveReceiveAddress: builder.query({
      query: ({ customerId, isActive=true }) => ({
        method: 'GET',
        path: `Addresses/GetActiveRecieveAddresses/${customerId}?isActive=${isActive}`,
      }),
      providesTags: ['address'],
    }),
    getSearchTaxOffice: builder.query({
      query: ({ text }) => ({
        method: 'GET',
        path: `PublicData/GetTaxOffices/${text}`,
      }),
    }),
    getCustomerAddress: builder.query({
      query: ({ id, isActive=true }) => ({
        method: 'GET',
        path: `Addresses/GetCustomerAddresses/${id}?isActive=${isActive}`,
      }),
      providesTags: ['address'],
    }),
    getAddressInfo: builder.query({
      query: ({ id }) => ({
        method: 'GET',
        path: `Addresses/GetAnAddress/${id}`,
      }),
    }),
    getAddresses: builder.query({
      query: ({ customerId, isActive=true } ) => ({
        method: 'GET',
        path: `Addresses/GetAddress/${customerId}?isActive=${isActive}`,
      }),
      providesTags: ['address'],
    }),
    deleteAddress: builder.mutation({
      query: ({ id }) => ({
        method: 'DELETE',
        path: `Addresses/RemoveAddress/${id}`,
      }),
      invalidatesTags: ['address'],
    }),
    createNewAddress: builder.mutation({
      query: ({ data }) => ({
        data,
        method: 'POST',
        path: 'Addresses/NewAddress',
      }),
      invalidatesTags: ['address'],
    }),
    createNewAddressList: builder.mutation({
      query: ({ data }) => ({
        data,
        method: 'POST',
        path: 'Addresses/NewAddressList',
      }),
      invalidatesTags: ['address'],
    }),
    updateAddress: builder.mutation({
      query: ({ data }) => ({
        data,
        method: 'POST',
        path: 'Addresses/UpdateAddress',
      }),
      invalidatesTags: ['address'],
    }),
    updateAddressStatusActive: builder.mutation({
      query: ({ id }) => ({
        method: 'PUT',
        path: `Addresses/ActivateAddress/${id}`,
      }),
      invalidatesTags: ['address'],
    }),
    updateAddressStatusPassive: builder.mutation({
      query: ({ id }) => ({
        method: 'DELETE',
        path: `Addresses/RemoveAddress/${id}`,
      }),
      invalidatesTags: ['address'],
    }),

  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const addressApiReducerName = addressApi.reducerPath;
export const addressApiReducer = addressApi.reducer;
export const addressApiMiddleware = addressApi.middleware;

export const {
  useGetAddressListQuery,
  useGetCustomerAddressQuery,
  useGetSearchTaxOfficeQuery,
  useGetAddressInfoQuery,
  useGetAddressesQuery,
  useCreateNewAddressMutation,
  useCreateNewAddressListMutation,
  useUpdateAddressMutation,
  useDeleteAddressMutation,
  useUpdateAddressStatusActiveMutation,
  useUpdateAddressStatusPassiveMutation,
  useGetActiveReceiveAddressQuery,
  useGetCustomerInfoByIdQuery,
  useGetAddressBookByIdQuery,
} = addressApi;
